import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './styles/index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 注意：不要在此处包裹 React.StrictMode —— @hello-pangea/dnd 官方不支持 StrictMode，
// 双重渲染会导致拖拽中列表跳变、掉帧（本页大量使用 dnd 排序）
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
